import React from 'react';

import useIsMobile from 'hooks/useIsMobile';
import { GroupedSectorOptions } from 'models/flightSearch';

import FlightOptionDesktop from './FlightOptionDesktop';
import FlightOptionMobile from './FlightOptionMobile';

interface Props {
  groupedSectorOption: GroupedSectorOptions;
}

const FlightOption = (props: Props) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return <FlightOptionMobile {...props} />;
  }

  return <FlightOptionDesktop {...props} />;
};

export default FlightOption;
